import { Component, OnInit, Output, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalPurchaseComponent } from '../../components/modal-purchase/modal-purchase.component';
import { ModalUnpaidComponent } from '../../components/modal-unpaid/modal-unpaid.component';
import {
  CANCEL_INVOICE,
  CART_PACKAGE,
  CHECK_ACTIVE,
  LIST_PACKAGE,
  PAY_PACKAGE,
} from 'src/app/constants/endpoint.const';
import { BaseService } from 'src/app/services/base.service';
import { cartListType } from 'src/app/types/response/billings-response.type';
import { NzMessageService } from 'ng-zorro-antd/message';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export interface PackageItem {
  id: number;
  level_type: number;
  duration: number;
  discounted_price: number;
  tax: number;
  original_price: number;
}

@Component({
  standalone: false,
  selector: 'app-choose-package',
  templateUrl: './choose-package.component.html',
  styleUrls: ['./choose-package.component.scss'],
})
export class ChoosePackageComponent implements OnInit {
  selectedPackage: number = 1;
  isPro: boolean = true;
  cartListData!: cartListType;
  packageList: PackageItem[] = [];
  @Output() invoiceId!: string;
  totalPrice: number = 0;
  enterPriseMember: boolean = false;
  greatDisc: boolean = false;
  loading: boolean = true;

  private route = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private BaseService = inject(BaseService);
  private modalService = inject(NgbModal);
  private message = inject(NzMessageService);
  private destroyRef = inject(DestroyRef);

  ngOnInit() {
    const duration = this.activatedRoute.snapshot.queryParamMap.get('duration');
    const selectedPackage =
      this.activatedRoute.snapshot.queryParamMap.get('package');

    if (selectedPackage === 'pro') {
      this.selectedPackage = duration === 'annualy' ? 4 : 1;
      this.isPro = true;
      this.getListPackage(2);
    } else if (selectedPackage === 'enterprise') {
      this.selectedPackage = duration === 'annualy' ? 8 : 5;
      this.isPro = false;
      this.getListPackage(3);
    }

    if (localStorage.getItem('active_package') === 'enterprise') {
      this.enterPriseMember = true;

      const currentUrl = window.location.href;
      if (
        currentUrl.includes(
          '/subscriptions/upgrade-package/choose-package?package=pro'
        )
      ) {
        window.location.href =
          '/subscriptions/upgrade-package/choose-package?package=enterprise';
      }
    } else {
      this.enterPriseMember = false;
    }
    setTimeout(()=>{
      this.loading = false
    }, 1000)
  }

  back() {
    this.route.navigate(['/subscriptions/upgrade-package']);
  }

  switchPro(): void {
    if (localStorage.getItem('active_package') === 'enterprise') {
      this.message.create('error', "Can't Downgrade Package");
    } else {
      this.selectedPackage = 1;
      this.isPro = true;
      this.route.navigate(['/subscriptions/upgrade-package/choose-package'], {
        queryParams: { package: 'pro' },
      });
      this.getListPackage(2);
    }
  }

  switchEnterprise(): void {
    this.selectedPackage = 5;
    this.isPro = false;
    this.route.navigate(['/subscriptions/upgrade-package/choose-package'], {
      queryParams: { package: 'enterprise' },
    });
    this.getListPackage(3);
  }

  handlePurchase(e: number) {
    this.BaseService.getData(CHECK_ACTIVE + '?type=subscription')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (res) => {
          const { have_active_bill, qr_expire_date, invoice_xendit_id, qr_xendit_id, allow_qr, qr_amount, qr_xendit_qrstring, invoice_xendit_url } = res.data;
          const currentTime = new Date();
          const expireDate = new Date(qr_expire_date);
          const isExpired = expireDate < currentTime;

          const invoiceID = invoice_xendit_id || qr_xendit_id;
          const isQris = !invoice_xendit_id;

          // Function to open the purchase modal
          const openPurchaseModal = () => {
            const modal = this.modalService.open(ModalPurchaseComponent, {
              size: 'lg',
              backdrop: 'static',
              keyboard: false,
              centered: true,
            });

            Object.assign(modal.componentInstance, {
              invoiceID,
              allowQris: allow_qr,
              packageId: this.selectedPackage,
              totalPrice: qr_amount,
              expiredAt: qr_expire_date,
              qrCode: qr_xendit_qrstring,
            });
          };

          // Function to open the unpaid modal
          const openUnpaidModal = () => {
            const modal = this.modalService.open(ModalUnpaidComponent, {
              backdrop: 'static',
              centered: true,
              size: 'md',
            });

            Object.assign(modal.componentInstance, {
              invoiceID,
              allowQris: allow_qr,
              packageId: this.selectedPackage,
              totalPrice: this.totalPrice,
              expiredAt: qr_expire_date,
              urlPayment: invoice_xendit_url,
              qrCode: qr_xendit_qrstring,
              isQris,
            });
          };

          // Handle expired invoices with active bills
          if (isExpired && have_active_bill) {
            if (res.data.qr_xendit_id !== '') {
              const params = { invoice_id: invoiceID };

              this.BaseService.putData(CANCEL_INVOICE, params)
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(
                  () => (e <= 500000 ? openPurchaseModal() : this.payNow(this.selectedPackage)),
                  (err) => this.message.create('error', err.error.data.errors)
                );
            } else {
              openUnpaidModal();
            }
          } else if (!have_active_bill) {
            e <= 500000 ? openPurchaseModal() : this.payNow(this.selectedPackage);
          } else {
            openUnpaidModal();
          }
        },
        (err) => {
          this.message.create('error', err.error.data.errors);
        }
      );
  }


  payNow(e: number) {
    const params = {
      payment_method: 'bank_transfer',
      package_id: e,
    };
    this.BaseService.postData(PAY_PACKAGE, params)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (res) => {
          window.open(res.data.invoice_url, '_blank');
        },
        (err) => {
          this.message.create('error', err.error.data.errors);
        }
      );
  }

  handleSelected(e: number) {
    this.selectedPackage = e;
    this.getCartList(e);
  }

  getListPackage(e: number) {
    const params = {
      level: e,
    };
    this.BaseService.getData(LIST_PACKAGE, params)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (res) => {
          this.packageList = res.data;

          const duration =
            this.activatedRoute.snapshot.queryParamMap.get('duration');
          const selectedPackage =
            this.activatedRoute.snapshot.queryParamMap.get('package');
          if (selectedPackage === 'enterprise') {
            if (duration === 'annualy') {
              this.getCartList(8);
            } else {
              this.getCartList(5);
            }
          } else {
            if (duration === 'annualy') {
              this.getCartList(4);
            } else {
              this.getCartList(1);
            }
          }
          this.message.create('warning', 'Your Current Package Options');
        },
        (err) => {
          if (err.error.data.errors === 'cannot downgrade package') {
            this.message.create('error', "Can't Downgrade Package");
          }
        }
      );
  }

  getCartList(e: number) {
    const params = {
      package_id: e,
    };
    this.BaseService.getData(CART_PACKAGE, params)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (res) => {
          this.cartListData = res.data;
          this.totalPrice = res.data.total;
          this.greatDisc = false;
        },
        (err) => {
          if (
            err.error.meta.message ===
            'cannot upgrade to this package when upgrade discount is greater than package price'
          ) {
            this.greatDisc = true;
            this.message.create(
              'error',
              "Can't upgrade to this package, the discount is greater than package price"
            );
          } else if (err.error.meta.message === 'cannot downgrade package') {
            this.message.create('error', "Can't Downgrade Package");
            this.greatDisc = true;
          } else {
            this.greatDisc = false;
          }

          this.cartListData = err.error.data;
          this.cartListData.total = 0;
        }
      );
  }

  descName(e: number) {
    if (e === 1) return '1 Month';
    else return e + ' Months';
  }

  handleMonth(e: number) {
    if (e === 1 || e === 5) return '1 Month';
    if (e === 2 || e === 6) return '3 Months';
    if (e === 3 || e === 7) return '6 Months';
    if (e === 4 || e === 8) return '12 Months';
    return '';
  }
}
